module.exports = __webpack_public_path__ + "img/08.8bbf4c0b.png";